// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"ProfilesApprovals_searchBar__IENr_"};